export default {
	siret: 'Siret',
	nom: 'Nom',
	prenom: 'Prénom',
	password: 'Mot de passe',
	forgottenPwd: 'Mot de passe oublié ?'
};
